<div class="stop-onboarding-container">
    <div class="stop-onboarding-illustration-wrapper">
        <img class="stop-onboarding-illustration-img"
            src="assets/images/illustrations--SomthingWentWrong.svg" alt="Manage Bookings" width="180"
            height="134">
        <div class="stop-onboarding-description-wrapper">
            <!-- <h3 class="title">{{ heading }}</h3> -->
            <h3 class="title">{{ alreadyRegisteredMessage?.title || 'Already Registered Email Address' }}</h3>
            <div class="content text-center">
                <!-- <p>{{ content }}
                    <span class="email" *ngIf="IsShowEmail">{{email}}</span>
                    {{ content }}
                </p> -->
                <p>{{splitDescription[0]}}<span class="email" *ngIf="splitDescription.length > 1">{{fetchMatchedEmail}}</span>{{splitDescription[1]}}</p>
            </div>
            @if (IsShow) {
            <button mat-button class="button--primary-small m-top-8x" [routerLink]="navigateTo">
                {{ manageTravelerDataContent?.['b2b.managetraveler.efregeneratelink'] || 'Click to regenerate link' }}
                <mat-icon fontSet="material-symbols-outlined"> arrow_forward </mat-icon>
            </button>
            }
        </div>
    </div>
</div>